import { defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-801909c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form__checkbox-group" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form__checkbox-button" }, null, -1))
const _hoisted_4 = { class: "form__checkbox-label-text" }

import { computed } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  isInsurance: {
    type: Boolean,
    default: false,
  },

  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;





const sharedId = "checkbox_" + Math.floor(Math.random() * 1000000);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      disabled: __props.disabled,
      class: "form__checkbox-input",
      id: sharedId
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, value.value]
    ]),
    _createElementVNode("label", {
      for: sharedId,
      class: "form__checkbox-label"
    }, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.label), 1)
    ])
  ]))
}
}

})